import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles.css';
import { Apply } from './pages/Apply.jsx';
import { Expired } from './pages/Expired.jsx';
import { Completed } from './pages/Completed.jsx';
import { NotFound } from './pages/NotFound.jsx';
import { Signer } from './pages/Signer.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/a/:token" element={<Apply />} />
        <Route path="/sign/:signerToken" element={<Signer />} />
        <Route path="/expired" element={<Expired />} />
        <Route path="/completed/:token" element={<Completed />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
